import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { APP_ROUTES } from '@app/app.routes.model';
import { AppApi } from '@api/AppApi';
import { map, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { StorageService } from '../services/storage/storage.service';

export const isTeamMemberGuard: CanActivateFn = (route) => {
  const api = inject(AppApi);
  const router = inject(Router);
  const isHd$$ = inject(StorageService).isHdUser$$;

  // HD brokers dont have rights for Team API, but have the rights to visit pages that require organization user to be in a team.
  if (isHd$$()) {
    return true;
  }

  return api.commonTeam.getAllTeams().pipe(
    catchError((error: HttpErrorResponse) => {
      router.navigate([APP_ROUTES.home]);
      return throwError(() => new Error(error.message));
    }),
    map((teamList) => {
      if (teamList.length) {
        return true;
      }

      router.navigate([APP_ROUTES.notTeamMember], {
        queryParams: { page: `${route.data['pageName']}` },
      });
      return false;
    }),
  );
};
